export function LikesCounterSkeleton() {
  return <div className="animate-pulse w-[52px]">...</div>
}
